import type { ReactNode } from 'react';

/** One choice of an OptionSelect. `value: ''` is the "none" choice ("App: all", "Not linked", "any visibility"). */
export interface SelectOption {
  value: string;
  label: ReactNode;
  disabled?: boolean;
}

/** Radix Select items cannot carry an empty string, so the "none" choice travels as this sentinel inside the select. */
export const NONE_VALUE = '__none__';

/** The item value for an option: '' becomes the sentinel. */
export const toItemValue = (value: string): string => (value === '' ? NONE_VALUE : value);

/**
 * The Root value for the caller's value: '' selects the "none" option when the list has one; otherwise '' stays '' and
 * Radix shows the placeholder ("Pick", "Select a repository", "Loading…").
 */
export function rootValue(value: string, options: readonly SelectOption[]): string {
  return value === '' && options.some((o) => o.value === '') ? NONE_VALUE : value;
}

/**
 * The caller's value for a Radix change, or undefined to ignore it: no item carries '', so an empty change is Radix's
 * hidden form <select> resetting itself (options list changed, form reset), never the user's pick.
 */
export function fromItemValue(value: string): string | undefined {
  if (value === '') return undefined;
  return value === NONE_VALUE ? '' : value;
}
